import React from 'react';
import PropTypes from 'prop-types';
import { Col, FormGroup, ControlLabel, FormControl, HelpBlock } from 'react-bootstrap';
import ui from '../../services/ui';
import utils from '../../services/utils';

const Static = ({ horizontal, input: { value }, formatType, label, help, valueWrapper, labelCol = 2, valueCol = 10, labelSize, ...props }) => {
	switch (formatType) {
		case 'date':
			value = ui.formatDate(value);
			break;
		case 'dateTime':
			value = ui.formatDateTime(value);
			break;
		case 'time':
			value = ui.formatTime(utils.parseTime(value));
			break;
		case 'boolean':
			value = ui.formatBoolean(value);
			break;
		case 'html':
			value = <div dangerouslySetInnerHTML={{ __html: value }} />;
			break;
		case 'double':
			value = ui.formatAmount(value);
			break;
	}

	const formControl = <FormControl.Static>{valueWrapper && typeof valueWrapper === 'function' ? valueWrapper(value) : value}</FormControl.Static>;
	const helpBlock = help && <HelpBlock>{help}</HelpBlock>;
	if (horizontal) {
		return (
			<FormGroup >
				<Col componentClass={ControlLabel} sm={labelSize || labelCol}>
					{label}
				</Col>
				<Col sm={labelSize ? 12 - labelSize : valueCol}>
					{formControl}
					{helpBlock}
				</Col>
			</FormGroup>);
	}

	return (
		<FormGroup>
			<ControlLabel>{label}</ControlLabel>
			{formControl}
			{helpBlock}
		</FormGroup>
	);
};

Static.propTypes = {
	horizontal: PropTypes.bool,
	input: PropTypes.object,
	label: PropTypes.string,
	componentClass: PropTypes.string,
	value: PropTypes.string,
};

export default Static;